import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  const isForYou = ['Sientes pesadez abdominal y cansancio extremo al despertar.', 'Tienes miedo de desarrollar pre-diabetes como otros familiares.', 'Trabajas mucho y no tienes tiempo de cocinar platos complicados.', 'Quieres volver a usar la ropa que ya tienes en el clóset.'];
  const notForYou = ['Buscas una pastilla milagrosa para bajar 20 kilos en una noche.', 'No estás dispuesta a cambiar tu café con azúcar por mi versión con especias.', 'Prefieres seguir gastando en ropa de una talla más grande cada seis meses.'];
  return <section className="py-16 md:py-24 bg-cream-dark" data-id="element-94">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-96">
          {/* ESTO ES PARA TI SI */}
          <FadeIn direction="right" data-id="element-97">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-green-100 h-full" data-id="element-98">
              <h3 className="text-2xl font-bold text-dark-brown mb-8 flex items-center" data-id="element-99">
                <span className="bg-green-100 text-green-700 p-2 rounded-full mr-4" data-id="element-100">
                  <Check className="w-6 h-6" data-id="element-101" />
                </span>
                ESTO ES PARA TI SI:
              </h3>
              <ul className="space-y-6" data-id="element-102">
                {isForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-103">
                    <Check className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-104" />
                    <span className="text-lg text-dark-brown/80" data-id="element-105">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* ESTO NO ES PARA TI SI */}
          <FadeIn direction="left" delay={0.2} data-id="element-106">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-red-100 h-full" data-id="element-107">
              <h3 className="text-2xl font-bold text-dark-brown mb-8 flex items-center" data-id="element-108">
                <span className="bg-red-100 text-red-700 p-2 rounded-full mr-4" data-id="element-109">
                  <X className="w-6 h-6" data-id="element-110" />
                </span>
                ESTO NO ES PARA TI SI:
              </h3>
              <ul className="space-y-6" data-id="element-111">
                {notForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-112">
                    <X className="w-6 h-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-113" />
                    <span className="text-lg text-dark-brown/80" data-id="element-114">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}